module.exports = __webpack_public_path__ + "static/img/1.bf8807e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/1.png
// module id = KM/y
// module chunks = 35